import React from "react" 
import { Container, Row, Col, Form } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import parse from 'html-react-parser';
import Img from 'gatsby-image';
import GenerateLink from "../common/site/generate-link" 
import { isMobile } from 'react-device-detect';
import "./ServiceContentTwo.scss"
const ServiceContentTwo = (props) => {
    return (
        <React.Fragment>
            <section className={`our-mortgage components--AreaGuideDetails--OurMortgage--OurMortgage ${props.class}`}>
                <Container>
                        <Row>
                        {props.Add_New_Block && props.Add_New_Block.slice(props.num,10).map((service, i) => {
                            return (
                                <Col md="12" lg="6">
                                <ScrollAnimation animateIn={`${isMobile ? "fadeInUp" : (i%2==0 ? "fadeInLeft" : 'fadeInRight')}`} animateOnce>
                                    <div className="mortgage-content">
                                    <div className="img-zoom about-block-img working-img-block">
                                    {service.Image &&
                                        <Img fluid={service.Image.url_sharp.childImageSharp.fluid} alt={service.Image.alternativeText} />
                                    }
                                        </div>
                                        <div className="about-content">
                                            {service.Title &&
                                            <span className="sub-title">{service.Title}</span>
                                            }
                                            {parse(service.Content)}

                                            {service.CTA_Label &&
                                            <GenerateLink link={service.CTA_Link} class="btn">{service.CTA_Label}
                                            <i className="icon-arrow"></i>
                                            </GenerateLink>
                                            }
                                           {/* <div className="block-flex">
                                                  <Link href="#" className="btn">Speak to us<i className="icon-arrow"></i></Link>
                                                <div className="powerby">
                                                    <span>Powered by</span>
                                                    <img src={Mortgage} alt="" width="108"/>
                                                </div>
                                           </div> */}
                                        </div>
                                      
                                       
                                   
                                    </div>
                                    </ScrollAnimation>
                                </Col>
                            )
                        })}

                        
                        </Row>
                        
                    </Container>
                
            </section>
        </React.Fragment>
    )
}
export default ServiceContentTwo
